import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, useAttrs } from 'vue';

import DefaultSelect from '../components/DefaultSelect.vue';
import ItemLabel from '../components/ItemLabel.vue';

import type { ProductItem } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemProductInput',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const $attrs = useAttrs();

const error = computed(() => {
  const product = props.item.products.find((p) => p.id === $attrs.modelValue);

  if (!product) {
    return undefined;
  }

  if (product.is_archived) {
    return 'Wybrany produkt został zarchiwizowany';
  }

  if (!product.is_available) {
    return 'Wybrany produkt nie jest dostępny';
  }

  return undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["space-y-11", _unref($attrs).class])
  }, [
    _createVNode(DefaultSelect, _mergeProps(_unref($attrs), {
      options: 
        _ctx.item.products.filter(
          (product) =>
            (!product.is_archived && product.is_available) || product.id === _unref($attrs).modelValue
        )
      ,
      placeholder: "Wybierz produkt",
      optionLabel: "name",
      optionValue: "id",
      filter: "",
      "text-wrap": true,
      error: error.value
    }), {
      default: _withCtx(() => [
        _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
      ]),
      _: 1
    }, 16, ["options", "error"])
  ], 2))
}
}

})